import React from 'react'
import { MDXProvider } from '@mdx-js/react'
import mdxComponents from '../../Markdown/mdxComponents'
import LeftSidebar from '../LeftSidebar/LeftSidebar'
import RightSidebar from '../RightSidebar/RightSidebar'
import Header from '../Header/Header'
import { LeftSideBarStyle, MainContentWrapperStyle, RightSideBarStyle, WrapperStyle } from './Layout.css'



const Layout = ({ children, location }) => (
     <>
    <Header />
    <MDXProvider components={mdxComponents}>
      <div css={WrapperStyle}>
        <div css={LeftSideBarStyle}>
          <LeftSidebar location={location} />
        </div>
        <main css={MainContentWrapperStyle}>
          {children}
        </main>
        <div css={RightSideBarStyle}>
          <RightSidebar location={location} />
        </div>
      </div>
    </MDXProvider>
    </>
)

export default Layout
